import React, { useState, useEffect } from 'react';
import './building.css';
import Button from '../../../components/UI/Button/Button';
import Modal from '../../../modal/modal';
import ModalContent from '../../../modal/ModalContent';
import ModalFloorMap from '../../../components/modalContent/floorMap/floorMap';
import axiosInstance from '../../../utils/router/axiosInstance';
import ModalBuildingDelete from '../../../components/modalContent/buildingDelete/buildingDelete';
import { logger } from '../../../utils/logger';

const BuildingHeader = ({ onBuildingAndFloorChange, onBuildingChange, selectedFloorMain }) => {
  const [isModalActive, setIsModalActive] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [selectedFloor, setSelectedFloor] = useState('');
  const [xSize, setXSize] = useState('');
  const [ySize, setYSize] = useState('');
  const [floorPlanFile, setFloorPlanFile] = useState(null);
  const [isModalDeleteActive, setIsModalDeleteActive] = useState(false);

  useEffect(() => {
    try {
      const fetchBuildings = async () => {
        const response = await axiosInstance.get('website/buildings');
        const buildingsData = response.data;

        logger.debug(buildingsData, 'buildingsData');

        if (buildingsData.length > 0) {
          setBuildings(buildingsData);
          setSelectedBuilding(buildingsData[0]); // Устанавливаем первое здание как выбранное
          onBuildingChange(buildingsData[0].id);

          if (buildingsData[0].floor_amount > 0) {
            setSelectedFloor(1); // Устанавливаем первый этаж как выбранный
          }
        }
      };
      setSelectedFloor(1);
      fetchBuildings();
    } catch (error) {
      logger.error('Error fetching buildings data:', error);
    }
  }, []);

  const handleBuildingChange = (buildingId) => {
    const selectedBuilding = buildings.find((building) => building.id === parseInt(buildingId));
    logger.debug(selectedBuilding);
    setSelectedBuilding(selectedBuilding);
    if (selectedBuilding.floor_amount > 0) {
      setSelectedFloor(1); // Сбросить выбранный этаж на первый при смене здания
    } else {
      setSelectedFloor(1); // Если в здании нет этажей, сбросить выбранный этаж
    }
    onBuildingChange(selectedBuilding.id); // Передать идентификатор выбранного помещения в родительский компонент
  };

  const handleFloorChange = (floor) => {
    selectedFloorMain(parseFloat(floor));
    setSelectedFloor(parseInt(floor, 10));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFloorPlanFile(file);
  };

  const handleAddFloorPlan = () => {
    const buildingId = selectedBuilding.id;
    const floor = selectedFloor;
    const floorSize = { x: parseInt(xSize, 10), y: parseInt(ySize, 10) };

    const formData = new FormData();
    formData.append('floor', floor);
    // formData.append('width', floorSize.x);
    // formData.append('height', floorSize.y);
    formData.append('floor_size', JSON.stringify(floorSize));
    formData.append('floor_plan', floorPlanFile);

    axiosInstance
      .patch(`website/floors/${buildingId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        logger.debug('Floor plan added successfully:', response);
        alert('Этаж успешно добавлен/изменен');
        setFloorPlanFile(null);
      })
      .catch((error) => {
        logger.error('Error adding floor plan:', error);
        if (error.response && error.response.status === 418) {
          axiosInstance
            .patch(`website/floors/${buildingId}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              setFloorPlanFile(null);
            })
            .catch((error) => {
              logger.error('Error updating floor plan:', error);
            });
        }
      });
  };
  const handleFilter = () => {
    onBuildingAndFloorChange(selectedBuilding, selectedFloor);
  };

  return (
    <div className="buildingSettings">
      <div className="buildingSelectComponent">
        {/* <Button className={'floorMap1'} text="Фильтр" onClick={handleFilter} /> */}
        <Button className={'floorMap1'} text="Удалить" onClick={() => setIsModalDeleteActive(true)} />
        <label htmlFor="buildingSelect">Помещение:</label>
        <select
          id="buildingSelect"
          value={selectedBuilding.id}
          onChange={(e) => handleBuildingChange(e.target.value)}
        >
          {buildings.map((building) => (
            <option key={building.id} value={building.id}>
              {building.name}
            </option>
          ))}
        </select>
        <Modal
          active={isModalDeleteActive}
          setActive={setIsModalDeleteActive}
          width={'420px'}
          height={'600px'}
        >
          <ModalContent>
            <ModalBuildingDelete buildingId={selectedBuilding.id} setIsModalDeleteActive={setIsModalDeleteActive} />
          </ModalContent>
        </Modal>
      </div>

      {selectedBuilding && (
        <div className="floorSelectComponent">
          <label htmlFor="floorSelect">Этаж:</label>
          <select
            id="floorSelect"
            value={selectedFloor || 1}
            onChange={(e) => handleFloorChange(e.target.value)}
          >
            {[...Array(selectedBuilding.floor_amount).keys()].map((floor) => (
              <option key={floor + 1} value={floor + 1}>
                {floor + 1}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="floorMapComponent">
        <Button className={'floorMap'} text="Добавить помещение" onClick={() => setIsModalActive(true)} />
        <Button
          className={'floorMap'}
          text="Выбрать план этажа"
          onClick={() => document.getElementById('fileInput').click()}
        />
        <input
          id="fileInput"
          type="file"
          // WEB-3: PDF-план поддержан редактором (pdfjs -> 1-я стр. в PNG);
          // backend сигнатуру %PDF- принимает давно (uploads._SIGNATURES)
          accept="image/*,application/pdf"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        {floorPlanFile && (
          <Button
            className={`floorMap ${!xSize || !ySize || !floorPlanFile ? 'disabled' : ''}`}
            text="Сохранить"
            onClick={handleAddFloorPlan}
            disabled={!xSize || !ySize || !floorPlanFile}
          />
        )}
        <Modal active={isModalActive} setActive={setIsModalActive} width={'600px'} height={'200px'}>
          <ModalContent>
            <ModalFloorMap setIsModalActive={setIsModalActive} />
          </ModalContent>
        </Modal>
      </div>

      <div className="coordinatesComponent">
        <label htmlFor="xSizeInput">Площадь X:</label>
        <input
          className="xSizeInput"
          id="xSizeInput"
          type="text"
          value={xSize}
          onChange={(e) => setXSize(e.target.value)}
          placeholder='в метрах'
        />
        <label htmlFor="ySizeInput"> Y:</label>
        <input
          className="ySizeInput"
          id="ySizeInput"
          type="text"
          value={ySize}
          onChange={(e) => setYSize(e.target.value)}
          placeholder='в метрах'
        />
      </div>
    </div>
  );
};

export default BuildingHeader;
